import { Loader2 } from 'lucide-react';

export const SimpleLoader = (): JSX.Element => {
  return <Loader2 className="lucide-loader" size={16} />;
};
